import { localStorageApi } from '../../../helper/localStorageApi'
import { getLocalStorageRefreshToken, isClientMonitor } from '../../../helper/clientMonitor'
import { getCookieAccessToken, getCookieRefreshToken } from '../../../helper/cookieToken'

export const getAccessToken = () => {
	if (isClientMonitor()) {
		return localStorageApi.getItem('accessTokenClientMonitor')
	}
	return getCookieAccessToken() || localStorageApi.getItem('accessToken')
}

export const getRefreshToken = () => {
	if (isClientMonitor()) {
		return getLocalStorageRefreshToken()
	}
	return getCookieRefreshToken() || getLocalStorageRefreshToken()
}
